import { APP_STATUS } from 'config/config';
import { getPaymentStatus, checkIfPaymentExists } from 'services/Api';
import { IPaymentStatus } from 'types/Payment';

// eslint-disable-next-line import/prefer-default-export
export const getExistingPaymentStatus = async (paymentId: string) => {
  try {
    const paymentStatus: IPaymentStatus = await getPaymentStatus(paymentId);
    return paymentStatus.status;
  } catch (error) {
    return checkIfPaymentExists(paymentId)
      .then(() => APP_STATUS.EXISTS)
      .catch(() => {
        throw error;
      });
  }
};
